import { useState } from 'react';

import changesMan from '../../assets/images/changesMan.png';
import changesWoman from '../../assets/images/changesWoman.png';
import changesTattoo from '../../assets/images/changesTattoo.png';
import iconFinger from '../../assets/icons/iconFinger.svg';


function Changes() {
  let data = [changesMan, changesTattoo, changesWoman];
  
  const [images, setImages] = useState(data);

  const handleClick = (index) => {
    const newImages = [...images];

    [newImages[index], newImages[2]] = [newImages[2], newImages[index]];
    setImages(newImages);
    }

  return ( 
    <div className='changes' id='changes'>
      <div className='changes__background'></div>
      <div className='changes__background-bottom'></div>
      <div className='changes__wrapper'>
        <div className='changes__header'>
          <h2 className='changes__header-title'>СОМНЕВАЕТЕСЬ? 
            <span className='changes__header-title-blue'>ПОСМОТРИТЕ САМИ!</span>
          </h2>
        </div>
        <div className='changes__main changesMain'>
          <div className='changesMain__left'>
            <div className='changesMain__left-text'>
              <p>«Мы не создаём иллюзий, а помогаем телу стать лучше, активируя естественные процессы восстановления и улучшая лимфоток.<br/>Эти фото — реальные истории наших клиентов.»</p>
            </div>
            <div className='changesMain__left-images'>
              <div className='changesMain__left-imageWrapper'>
                <img className='changesMain__left-image' src={images[0]} alt="" />
                <button onClick={()=>handleClick(0)} className='changesMain__left-button'><img className='changesMain__left-button-image' src={iconFinger} alt="" /></button>
              </div>
              <div className='changesMain__left-imageWrapper'>
                <img className='changesMain__left-image' src={images[1]} alt="" />
                <button onClick={()=>handleClick(1)} className='changesMain__left-button'><img className='changesMain__left-button-image' src={iconFinger} alt="" /></button>
              </div>
            </div>
          </div>
          <div className="changesMain__right">
            <img className='changesMain__right-image' src={images[2]} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Changes;